import { addPvNew } from '../../../utils';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
export default {
  components: {},
  data() {
    return {
      wWidth: window.innerWidth || window.outerWidth
    };
  },
  props: {
    topPoiInfo: {
      type: Object,
      default: () => ({})
    },
    stbarHeight: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    addPvNew(['MCDfm.MCEDpoiugc.NewMedia.microDetail.poidetail.show'], {});
    this.$nextTick(() => {
      this.setTopTitleStyle();
    });
  },
  computed: {
    titleStyle() {
      const stbarHeight = this.stbarHeight;
      // 49 是pageTitle组件的高度
      const pageTitleHeight = 49;
      return {
        'top': `${stbarHeight + pageTitleHeight}px`
      };
    }
  },
  methods: {
    /**
     * 跳转到 H5 页面
     *
     * @param url - 待跳转的 URL
     */
    jumpToDetail(url) {
      openUrlByOpenApi(url);
      addPvNew(['MCDfm.MCEDpoiugc.NewMedia.microDetail.poidetail.click'], {});
    },
    setTopTitleStyle() {
      const distanceElement = this.$refs.distance;
      const locationElement = this.$refs.location;
      if (locationElement) {
        const marginAndPadding = 129; // 内边距之和为129px
        let maxWidth = this.wWidth - marginAndPadding; // 22 是 rightBtn 的 margin-left
        if (distanceElement) {
          maxWidth -= distanceElement.clientWidth;
        }
        locationElement.style.maxWidth = `${maxWidth}px`;
      }
    }
  }
};